import isDarkMode from '../../utils/isDarkMode';

const dark = isDarkMode();

export const violet = dark ? '#8877ef' : '#7b68ee';
export const golden = dark ? '#73BE73' : '#AE841A';
export const green = dark ? '#73BE73' : '#529c54';
export const red = dark ? '#E53B4A' : '#ff4e4e';
export const blue = dark ? '#6495ED' : '#4169E1';
